<template>
  <div class="content">
    <div class="order-sticky-scroll">
      <Navi class="order-sticky" tab-id="2" :form="form" @back="back()" />

      <h2 id="syaryo-top" class="page-title">車両情報入力</h2>

      <validation-observer ref="observer">
        <h4 class="page-sub-title pl-2 pl-md-4 mt-4 mt-md-5">車両</h4>
        <div class="section-wrapper">
          <section class="order-syaryo">
            <table class="table">
              <tr>
                <th>
                  車両タイプ
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-9 col-lg-5">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="SYARYO_TYPE_KBN"
                      >
                        <b-form-select
                          ref="SYARYO_TYPE_KBN"
                          v-model="syaryo.SYARYO_TYPE_KBN"
                          :state="errors.length ? false : null"
                          :options="syaryoTypeKbnList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  メーカー名
                  <span v-if="!isLease" class="must">必須</span>
                  <br />
                  車名
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row ml-3 ml-md-0">
                    <div class="row col-lg-5 px-0 pr-md-2 mb-2 mb-md-0">
                      <label class="col-md-4 mt-md-2 px-0 pl-md-3 m-0">
                        メーカー名
                      </label>
                      <validation-provider
                        v-slot="{ errors, touched }"
                        name="SYARYO_MAKER_MEI"
                        :rules="`${isLease ? '' : 'required|'}max:20|char`"
                        class="col-md-7 mb-md-2 mb-lg-0 px-0"
                      >
                        <vue-simple-suggest
                          ref="SYARYO_MAKER_MEI"
                          :class="{
                            'border-red':
                              (isVlidated || touched) && errors.length,
                          }"
                          v-model="syaryo.SYARYO_MAKER_MEI"
                          :max-suggestions="15"
                          :list="makerList"
                          :styles="
                            (isVlidated || touched) && errors.length
                              ? autoCompleteStyleError
                              : autoCompleteStyle
                          "
                          @suggestion-click="setSyameiList"
                          @blur="
                            setSyameiList()
                            syaryo.SYARYO_MAKER_MEI = replaceChar(
                              syaryo.SYARYO_MAKER_MEI
                            )
                          "
                          maxlength="20"
                          placeholder="トヨタ"
                          :filter-by-query="true"
                        />
                        <div
                          v-if="(isVlidated || touched) && errors.length"
                          class="invalid-feedback"
                          style="display: block"
                        >
                          <span class="border-red">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </div>
                    <div class="row col-lg-7 px-0 pl-md-2">
                      <label class="col-md-4 col-lg-1 mt-2 px-0 m-0">
                        車名
                      </label>
                      <validation-provider
                        v-slot="{ errors, touched }"
                        rules="required|max:20|char"
                        class="col-md-7 px-0"
                        name="SYARYO_MEI"
                      >
                        <vue-simple-suggest
                          ref="SYARYO_MEI"
                          :class="{
                            'border-red':
                              (isVlidated || touched) && errors.length,
                          }"
                          v-model="syaryo.SYARYO_MEI"
                          :max-suggestions="15"
                          :list="syameiList"
                          :styles="
                            (isVlidated || touched) && errors.length
                              ? autoCompleteStyleError
                              : autoCompleteStyle
                          "
                          maxlength="20"
                          placeholder="プリウス"
                          :filter-by-query="true"
                          @blur="
                            syaryo.SYARYO_MEI = replaceChar(syaryo.SYARYO_MEI)
                          "
                        />
                        <div
                          v-if="(isVlidated || touched) && errors.length"
                          class="invalid-feedback"
                          style="display: block"
                        >
                          <span class="border-red">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  車台番号・登録番号
                  <span class="must">必須</span>
                  <p v-if="!isLease" class="f-size-12">
                    ※どちらか一方を必ずご入力ください。
                  </p>
                </th>
                <td>
                  <div class="row ml-1 mr-1 mb-2">
                    <label ref="TOUROKU_BANGO" class="mt-2 mr-md-3 mb-0">
                      車台番号
                    </label>
                    <validation-provider
                      name="SYADAI_BANGO"
                      v-slot="{ errors }"
                      :rules="`${
                        isLease || !syaryo.TOUROKU_BANGO ? 'required|' : ''
                      }byte:20|max:20|char`"
                      class="col-md-4"
                    >
                      <b-form-input
                        ref="SYADAI_BANGO"
                        v-model="syaryo.SYADAI_BANGO"
                        :state="errors.length ? false : null"
                        placeholder="GGH20-1111111"
                        trim
                        maxlength="20"
                        @blur="
                          syaryo.SYADAI_BANGO = replaceChar(syaryo.SYADAI_BANGO)
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <div class="row ml-1 mb-2">
                    <label class="mt-2 mr-md-3 mb-0">登録番号</label>
                    <div v-if="isMobile" class="col-12" />
                    <validation-provider
                      name="torokubango1"
                      v-slot="{ errors }"
                      :rules="
                        isLease || isRequiredTorokuBnago ? 'required|' : ''
                      "
                      class="col-5 col-md-2 pr-0"
                    >
                      <b-form-select
                        ref="torokubango1"
                        v-model="syaryo.torokubango1"
                        :state="errors.length ? false : null"
                        :options="numberArea"
                        trim
                        @change="onChangeTorokubango"
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                    <span class="mt-1 mx-1">-</span>
                    <validation-provider
                      name="torokubango2"
                      v-slot="{ errors }"
                      :rules="`${
                        isLease || isRequiredTorokuBnago ? 'required|' : ''
                      }max:4|char`"
                      class="col-5 col-md-2 px-0"
                    >
                      <b-form-input
                        ref="torokubango2"
                        v-model="syaryo.torokubango2"
                        maxlength="4"
                        :state="errors.length ? false : null"
                        placeholder="500"
                        trim
                        @change="onChangeTorokubango"
                        @blur="
                          syaryo.torokubango2 = replaceChar(syaryo.torokubango2)
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                    <span class="mt-1 mx-1">-</span>
                    <validation-provider
                      name="torokubango3"
                      v-slot="{ errors }"
                      :rules="`${
                        isLease || isRequiredTorokuBnago ? 'required|' : ''
                      }max:2|char`"
                      class="col-5 col-md-1 pr-0 px-md-0 mt-2 mt-md-0"
                    >
                      <b-form-input
                        ref="torokubango3"
                        v-model="syaryo.torokubango3"
                        maxlength="2"
                        :state="errors.length ? false : null"
                        placeholder="と"
                        trim
                        @change="onChangeTorokubango"
                        @blur="
                          syaryo.torokubango3 = replaceChar(syaryo.torokubango3)
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                    <span class="mt-1 mx-1">-</span>
                    <validation-provider
                      name="torokubango4"
                      v-slot="{ errors }"
                      :rules="`${
                        isLease || isRequiredTorokuBnago ? 'required|' : ''
                      }max:6|char`"
                      class="col-5 col-md-2 px-0 mt-2 mt-md-0"
                    >
                      <b-form-input
                        ref="torokubango4"
                        v-model="syaryo.torokubango4"
                        maxlength="6"
                        :state="errors.length ? false : null"
                        placeholder="1234"
                        trim
                        @change="onChangeTorokubango"
                        @blur="
                          syaryo.torokubango4 = replaceChar(syaryo.torokubango4)
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                </td>
              </tr>
              <tr>
                <th>長さ・幅・高さ(cm)</th>
                <td>
                  <div class="row mr-1 mb-2">
                    <div class="col-4 col-md-3 pr-0">
                      <div class="row">
                        <label
                          class="col-4 col-md-5 col-lg-4 mt-2 ml-md-1 pr-0"
                        >
                          長さ
                        </label>
                        <validation-provider
                          name="SYARYO_NAGASA"
                          v-slot="{ errors }"
                          rules="numeric|max:3"
                          class="col-8 col-md-6 px-md-0"
                        >
                          <b-form-input
                            ref="SYARYO_NAGASA"
                            type="tel"
                            maxlength="3"
                            v-model="syaryo.SYARYO_NAGASA"
                            :state="errors.length ? false : null"
                            placeholder="450"
                            trim
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                    </div>
                    <div class="col-4 col-md-3 pr-0">
                      <div class="row">
                        <label
                          class="col-3 col-md-4 col-lg-3 mt-2 ml-md-1 pr-0"
                        >
                          幅
                        </label>
                        <validation-provider
                          name="SYARYO_HABA"
                          v-slot="{ errors }"
                          rules="numeric|max:3"
                          class="col-8 col-md-6 px-md-0"
                        >
                          <b-form-input
                            ref="SYARYO_HABA"
                            type="tel"
                            maxlength="3"
                            v-model="syaryo.SYARYO_HABA"
                            :state="errors.length ? false : null"
                            placeholder="170"
                            trim
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                    </div>
                    <div class="col-4 col-md-3 px-0">
                      <div class="row">
                        <label
                          class="col-4 col-md-5 col-lg-4 mt-2 ml-md-1 pr-0"
                        >
                          高さ
                        </label>
                        <validation-provider
                          name="SYARYO_TAKASA"
                          v-slot="{ errors }"
                          rules="numeric|max:3"
                          class="col-8 col-md-6 px-md-0"
                        >
                          <b-form-input
                            ref="SYARYO_TAKASA"
                            type="tel"
                            maxlength="3"
                            v-model="syaryo.SYARYO_TAKASA"
                            :state="errors.length ? false : null"
                            placeholder="140"
                            trim
                          />
                          <b-form-invalid-feedback>
                            <span class="border-red">{{ errors[0] }}</span>
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>貴社管理番号</th>
                <td>
                  <validation-provider
                    name="KISYA_KANRI_BANGO"
                    v-slot="{ errors }"
                    rules="max:20|char"
                  >
                    <b-form-input
                      ref="KISYA_KANRI_BANGO"
                      class="col-md-6"
                      maxlength="20"
                      v-model="syaryo.KISYA_KANRI_BANGO"
                      :state="errors.length ? false : null"
                      placeholder="12345"
                      trim
                      @blur="
                        syaryo.KISYA_KANRI_BANGO = replaceChar(
                          syaryo.KISYA_KANRI_BANGO
                        )
                      "
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
              <tr>
                <th>下取り車両</th>
                <td>
                  <div class="row">
                    <div class="col-md-5">
                      <validation-provider
                        v-slot="{ errors }"
                        name="SHITADORI_FLG"
                      >
                        <b-form-select
                          ref="SHITADORI_FLG"
                          v-model="syaryo.SHITADORI_FLG"
                          :state="errors.length ? false : null"
                          :options="ariNasiList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="isLease && Number(syaryo.SHITADORI_FLG)">
                <th>
                  輸送先
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <label class="col-12 col-md-3 col-lg-1 mt-2 ml-md-3 pr-0">
                      輸送先
                    </label>
                    <div class="col-12 col-md-6 col-lg-4">
                      <validation-provider
                        v-slot="{ errors }"
                        name="YUSOSAKI_KBN"
                      >
                        <b-form-select
                          ref="YUSOSAKI_KBN"
                          v-model="syaryo.YUSOSAKI_KBN"
                          class="mb-2 mb-lg-0"
                          :state="errors.length ? false : null"
                          :options="yusosakiLeaseList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <div v-if="Number(syaryo.YUSOSAKI_KBN) === 9" class="mt-2">
                    <validation-provider
                      v-slot="{ errors }"
                      name="YUSOSAKI_FREE"
                      rules="max:200|char"
                    >
                      <b-form-textarea
                        ref="YUSOSAKI_FREE"
                        v-model="syaryo.YUSOSAKI_FREE"
                        :state="errors.length ? false : null"
                        placeholder="輸送先を入力してください"
                        trim
                        maxlength="200"
                        @blur="
                          syaryo.YUSOSAKI_FREE = replaceChar(
                            syaryo.YUSOSAKI_FREE
                          )
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                </td>
              </tr>
              <tr v-if="!isLease && Number(syaryo.SHITADORI_FLG)">
                <th>
                  輸送先・書類の送付物
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <label class="col-12 col-md-3 col-lg-1 mt-2 ml-md-3 pr-0">
                      輸送先
                    </label>
                    <div class="col-12 col-md-6 col-lg-4">
                      <validation-provider
                        v-slot="{ errors }"
                        name="YUSOSAKI_KBN"
                      >
                        <b-form-select
                          ref="YUSOSAKI_KBN"
                          v-model="syaryo.YUSOSAKI_KBN"
                          class="mb-2 mb-lg-0"
                          :state="errors.length ? false : null"
                          :options="yusosakiList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                    <label
                      v-if="Number(syaryo.YUSOSAKI_KBN) === 1"
                      class="col-12 col-md-3 col-lg-2 mt-2 ml-md-3 pr-0"
                    >
                      書類の送付物
                    </label>
                    <div
                      v-if="Number(syaryo.YUSOSAKI_KBN) === 1"
                      class="col-12 col-md-6 col-lg-3"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        name="SOUFUBUTU_KBN"
                      >
                        <b-form-select
                          ref="SOUFUBUTU_KBN"
                          v-model="syaryo.SOUFUBUTU_KBN"
                          :state="errors.length ? false : null"
                          :options="docSoufubutuList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="Number(syaryo.SHITADORI_FLG)">
                <th>
                  下取り車両タイプ
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-9 col-lg-5">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="SHITADORI_SYARYO_TYPE_KBN"
                      >
                        <b-form-select
                          ref="SHITADORI_SYARYO_TYPE_KBN"
                          v-model="syaryo.SHITADORI_SYARYO_TYPE_KBN"
                          :state="errors.length ? false : null"
                          :options="syaryoTypeKbnList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="Number(syaryo.SHITADORI_FLG)">
                <th>
                  下取りメーカー名
                  <span v-if="!isLease" class="must">必須</span>
                  <br />
                  車名
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row ml-3 ml-md-0">
                    <div class="row col-lg-5 px-0 pr-md-2 mb-2 mb-md-0">
                      <label class="col-md-4 mt-md-2 px-0 pl-md-3 m-0">
                        メーカー名
                      </label>
                      <validation-provider
                        name="SHITADORI_SYARYO_MAKER_MEI"
                        v-slot="{ errors, touched }"
                        :rules="`${isLease ? '' : 'required|'}max:20|char`"
                        class="col-md-7 mb-md-2 mb-lg-0 px-0"
                      >
                        <vue-simple-suggest
                          ref="SHITADORI_SYARYO_MAKER_MEI"
                          :class="{
                            'border-red':
                              (isVlidated || touched) && errors.length,
                          }"
                          v-model="syaryo.SHITADORI_SYARYO_MAKER_MEI"
                          :max-suggestions="15"
                          :list="makerList"
                          :styles="
                            (isVlidated || touched) && errors.length
                              ? autoCompleteStyleError
                              : autoCompleteStyle
                          "
                          @suggestion-click="setSyameiList"
                          @blur="
                            setSyameiList()
                            syaryo.SHITADORI_SYARYO_MAKER_MEI = replaceChar(
                              syaryo.SHITADORI_SYARYO_MAKER_MEI
                            )
                          "
                          :max-length="20"
                          placeholder="トヨタ"
                          :filter-by-query="true"
                        />
                        <div
                          v-if="(isVlidated || touched) && errors.length"
                          class="invalid-feedback"
                          style="display: block"
                        >
                          <span class="border-red">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </div>
                    <div class="row col-lg-7 px-0 pl-md-2">
                      <label class="col-md-4 col-lg-1 mt-2 px-0 m-0">
                        車名
                      </label>
                      <validation-provider
                        v-slot="{ errors, touched }"
                        rules="required|max:20|char"
                        class="col-md-7 px-0"
                        name="SHITADORI_SYARYO_MEI"
                      >
                        <vue-simple-suggest
                          ref="SHITADORI_SYARYO_MEI"
                          :class="{
                            'border-red':
                              (isVlidated || touched) && errors.length,
                          }"
                          v-model="syaryo.SHITADORI_SYARYO_MEI"
                          :max-suggestions="15"
                          :list="syameiList"
                          :styles="
                            (isVlidated || touched) && errors.length
                              ? autoCompleteStyleError
                              : autoCompleteStyle
                          "
                          maxlength="20"
                          placeholder="プリウス"
                          :filter-by-query="true"
                          @blur="
                            syaryo.SHITADORI_SYARYO_MEI = replaceChar(
                              syaryo.SHITADORI_SYARYO_MEI
                            )
                          "
                        />
                        <div
                          v-if="(isVlidated || touched) && errors.length"
                          class="invalid-feedback"
                          style="display: block"
                        >
                          <span class="border-red">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="Number(syaryo.SHITADORI_FLG)">
                <th>
                  下取り車台番号・登録番号
                  <span class="must">必須</span>
                  <p v-if="!isLease" class="f-size-12">
                    ※どちらか一方を必ずご入力ください。
                  </p>
                </th>
                <td>
                  <div class="row ml-1 mr-1 mb-2">
                    <label class="mt-2 mr-md-3 mb-0">車台番号</label>
                    <validation-provider
                      name="SHITADORI_SYADAI_BANGO"
                      v-slot="{ errors }"
                      :rules="`${
                        isLease || !syaryo.SHITADORI_TOUROKU_BANGO
                          ? 'required|'
                          : ''
                      }max:20|char`"
                      class="col-md-4"
                    >
                      <b-form-input
                        ref="SHITADORI_SYADAI_BANGO"
                        v-model="syaryo.SHITADORI_SYADAI_BANGO"
                        :state="errors.length ? false : null"
                        placeholder="GGH20-1111111"
                        trim
                        maxlength="20"
                        @blur="
                          syaryo.SHITADORI_SYADAI_BANGO = replaceChar(
                            syaryo.SHITADORI_SYADAI_BANGO
                          )
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <div class="row ml-1 mb-2">
                    <label
                      ref="SHITADORI_TOUROKU_BANGO"
                      class="mt-2 mr-md-3 mb-0"
                    >
                      登録番号
                    </label>
                    <div v-if="isMobile" class="col-12" />
                    <validation-provider
                      name="shitadoriTorokubango1"
                      v-slot="{ errors }"
                      :rules="
                        isLease || isRequiredShitadoriTorokuBnago
                          ? 'required|'
                          : ''
                      "
                      class="col-5 col-md-2 pr-0"
                    >
                      <b-form-select
                        ref="shitadoriTorokubango1"
                        v-model="syaryo.shitadoriTorokubango1"
                        :state="errors.length ? false : null"
                        :options="numberArea"
                        trim
                        @change="onShitadoriChangeTorokubango"
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                    <span class="mt-1 mx-1">-</span>
                    <validation-provider
                      name="shitadoriTorokubango2"
                      v-slot="{ errors }"
                      :rules="`${
                        isLease || isRequiredShitadoriTorokuBnago
                          ? 'required|'
                          : ''
                      }max:4|char`"
                      class="col-5 col-md-2 px-0"
                    >
                      <b-form-input
                        ref="shitadoriTorokubango2"
                        v-model="syaryo.shitadoriTorokubango2"
                        maxlength="4"
                        :state="errors.length ? false : null"
                        placeholder="500"
                        trim
                        @change="onShitadoriChangeTorokubango"
                        @blur="
                          syaryo.shitadoriTorokubango2 = replaceChar(
                            syaryo.shitadoriTorokubango2
                          )
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                    <span class="mt-1 mx-1">-</span>
                    <validation-provider
                      name="shitadoriTorokubango3"
                      v-slot="{ errors }"
                      :rules="`${
                        isLease || isRequiredShitadoriTorokuBnago
                          ? 'required|'
                          : ''
                      }max:2|char`"
                      class="col-5 col-md-1 pr-0 px-md-0 mt-2 mt-md-0"
                    >
                      <b-form-input
                        ref="shitadoriTorokubango3"
                        v-model="syaryo.shitadoriTorokubango3"
                        maxlength="2"
                        :state="errors.length ? false : null"
                        placeholder="と"
                        trim
                        @change="onShitadoriChangeTorokubango"
                        @blur="
                          syaryo.shitadoriTorokubango3 = replaceChar(
                            syaryo.shitadoriTorokubango3
                          )
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                    <span class="mt-1 mx-1">-</span>
                    <validation-provider
                      name="shitadoriTorokubango4"
                      v-slot="{ errors }"
                      :rules="`${
                        isLease || isRequiredShitadoriTorokuBnago
                          ? 'required|'
                          : ''
                      }max:6|char`"
                      class="col-5 col-md-2 px-0 mt-2 mt-md-0"
                    >
                      <b-form-input
                        ref="shitadoriTorokubango4"
                        v-model="syaryo.shitadoriTorokubango4"
                        maxlength="6"
                        :state="errors.length ? false : null"
                        placeholder="1234"
                        trim
                        @change="onShitadoriChangeTorokubango"
                        @blur="
                          syaryo.shitadoriTorokubango4 = replaceChar(
                            syaryo.shitadoriTorokubango4
                          )
                        "
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                </td>
              </tr>
              <tr>
                <th>車検の有無</th>
                <td>
                  <div class="ml-md-4">
                    <md-checkbox
                      ref="SYAKEN_FLG"
                      class="form-check-input md-primary"
                      true-value="1"
                      false-value="0"
                      v-model="syaryo.SYAKEN_FLG"
                    >
                      あり
                    </md-checkbox>
                  </div>
                </td>
              </tr>
              <tr v-if="isHikitoriAA">
                <th>
                  出品番号
                  <span class="must">必須</span>
                </th>
                <td>
                  <validation-provider
                    name="SYUPPIN_BANGO"
                    v-slot="{ errors }"
                    rules="required|max:20|char"
                  >
                    <b-form-input
                      ref="SYUPPIN_BANGO"
                      class="col-md-6"
                      maxlength="20"
                      v-model="syaryo.SYUPPIN_BANGO"
                      :state="errors.length ? false : null"
                      placeholder="123456"
                      trim
                      @blur="
                        syaryo.SYUPPIN_BANGO = replaceChar(syaryo.SYUPPIN_BANGO)
                      "
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                  <p v-if="!isLease" class="mt-2 red f-size-14">
                    ※出品番号によっては現車場所が異なる場合があります。今一度現車場所のご確認をお願いいたします。
                  </p>
                </td>
              </tr>
              <tr v-if="isHikitoriAA">
                <th ref="HANSYUTUKEN">
                  搬出券
                  <span class="must" v-if="isAAPosKbnTcWeb">必須</span>
                </th>
                <td>
                  <validation-provider
                    name="HANSYUTUKEN_URL"
                    v-slot="{ errors }"
                    :rules="{ required: isAAPosKbnTcWeb }"
                  >
                    <b-form-input
                      v-show="false"
                      v-model="syaryo.HANSYUTUKEN_URL"
                    />
                    <vue-dropzone
                      ref="HANSYUTUKEN_URL"
                      id="dropzone"
                      :options="dropzoneOptions"
                      :class="[
                        {
                          'border-red': errors.length,
                          'is-invalid': errors.length,
                        },
                      ]"
                      @vdropzone-processing="vfileSend"
                      @vdropzone-success="vfilesent"
                      @vdropzone-removed-file="removeFile"
                    />
                    <div v-if="errors.length" class="invalid-feedback">
                      <span class="border-red">{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                  <p class="mt-2 red f-size-14">
                    ※オークネット・シグマネット・TAA・JAA・ハナマル落札の場合、搬出券のアップロードが必須になります。
                  </p>
                </td>
              </tr>
              <tr>
                <th>その他ファイル</th>
                <td>
                  <vue-dropzone
                    ref="OTHER_FILE_LIST"
                    id="dropzone-other"
                    :options="dropzoneOtherOptions"
                    @vdropzone-processing="vfileOtherSend"
                    @vdropzone-success="vfileOtherSent"
                    @vdropzone-removed-file="removeOtherFile"
                    @vdropzone-file-added="addedOtherFile"
                  />
                </td>
              </tr>
            </table>
          </section>
        </div>

        <h4 class="page-sub-title pl-2 pl-md-4 mt-5" v-if="isNosyaYard">
          搬入時に必要な情報
        </h4>
        <div class="section-wrapper" v-if="isNosyaYard">
          <section class="order-hannyu">
            <table class="table">
              <tr>
                <th>
                  搬入名義
                  <span class="must">必須</span>
                </th>
                <td>
                  <validation-provider
                    name="HANNYU_MEI"
                    v-slot="{ errors }"
                    rules="required|max:25|char"
                  >
                    <b-form-input
                      ref="HANNYU_MEI"
                      class="col-md-8"
                      maxlength="25"
                      v-model="syaryo.HANNYU_MEI"
                      :state="errors.length ? false : null"
                      placeholder="株式会社○○"
                      trim
                      @blur="syaryo.HANNYU_MEI = replaceChar(syaryo.HANNYU_MEI)"
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
              <tr>
                <th>扱い名</th>
                <td>
                  <validation-provider
                    name="ATSUKAI_MEI"
                    v-slot="{ errors }"
                    rules="max:25|char"
                  >
                    <b-form-input
                      ref="ATSUKAI_MEI"
                      class="col-md-8"
                      maxlength="25"
                      v-model="syaryo.ATSUKAI_MEI"
                      :state="errors.length ? false : null"
                      placeholder="株式会社△△"
                      trim
                      @blur="
                        syaryo.ATSUKAI_MEI = replaceChar(syaryo.ATSUKAI_MEI)
                      "
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
              <tr>
                <th>向け地</th>
                <td>
                  <validation-provider
                    name="MUKETI_MEI"
                    v-slot="{ errors }"
                    rules="max:25|char"
                  >
                    <b-form-input
                      ref="MUKETI_MEI"
                      class="col-md-8"
                      maxlength="25"
                      v-model="syaryo.MUKETI_MEI"
                      :state="errors.length ? false : null"
                      placeholder="ニュージーランド"
                      trim
                      @blur="syaryo.MUKETI_MEI = replaceChar(syaryo.MUKETI_MEI)"
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
            </table>
          </section>
        </div>

        <h4 class="page-sub-title pl-2 pl-md-4 mt-5">状態確認</h4>
        <div class="section-wrapper">
          <section class="order-jyotai">
            <table class="table">
              <tr>
                <th>
                  自走してもよろしいですか？
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-6 col-lg-3">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="JISOU_KBN"
                      >
                        <b-form-select
                          ref="JISOU_KBN"
                          v-model="syaryo.JISOU_KBN"
                          :state="errors.length ? false : null"
                          :options="jisouKbnList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <p class="mt-2 red f-size-14">
                    ※積載指定の場合は料金が高額になる場合がございます
                    <span v-if="isLease">
                      <br />
                      ※積載対応不可のエリアもございます
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <th>
                  以下の項目に当てはまりますか？
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-3">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="JYOTAI_FLG"
                      >
                        <b-form-select
                          ref="JYOTAI_FLG"
                          v-model="syaryo.JYOTAI_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="mt-3">
                    <ul>
                      <li v-if="!isLease">自走不可（不動車・新古車）</li>
                      <li>ローダウン（地面からの距離15cm以下）</li>
                      <li>高額車（市場取引価格500万円以上）</li>
                      <li>クラシックカー（製造年が1989年以前）</li>
                      <li>改造車（車検が通らないもの）</li>
                    </ul>
                  </div>
                </td>
              </tr>
            </table>
          </section>
        </div>

        <h4 class="page-sub-title pl-2 pl-md-4 mt-5">名変輸送サービス</h4>
        <div class="section-wrapper">
          <section class="order-jyotai">
            <table class="table">
              <tr v-if="!isLease">
                <th>登録希望日</th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        name="MEIHEN_KIBO_BI"
                        v-slot="{ errors }"
                        rules="date"
                      >
                        <DatePicker
                          ref="MEIHEN_KIBO_BI"
                          clearable
                          :class="[{ 'border-red': errors.length }]"
                          placeholder="2019/01/01"
                          v-model="meihenKiboubi"
                        />
                        <div
                          v-if="errors.length"
                          class="ml-3 invalid-feedback"
                          style="display: block"
                        >
                          <span class="border-red">{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                  <p v-if="!isLease" class="mt-2 red f-size-14">
                    ※指定がない場合は書類が揃い次第登録させていただきます。
                  </p>
                </td>
              </tr>
              <tr v-if="!isLease">
                <th>
                  車検残の有無
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-6 col-lg-4">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="MEIHEN_SYAKEN_KBN"
                      >
                        <b-form-select
                          ref="MEIHEN_SYAKEN_KBN"
                          v-model="syaryo.MEIHEN_SYAKEN_KBN"
                          :state="errors.length ? false : null"
                          :options="syakenList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <p class="mt-2 red f-size-14">
                    ※ライン通し（車検）はお受けできません。
                  </p>
                </td>
              </tr>
              <tr>
                <th>
                  軽自動車ですか？
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-3">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="MEIHEN_KEI_FLG"
                      >
                        <b-form-select
                          ref="MEIHEN_KEI_FLG"
                          v-model="syaryo.MEIHEN_KEI_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoList"
                          trim
                          @change="setRikujiMeiAndCityCd()"
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="!isLease">
                <th v-if="syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_MEI">
                  <p>
                    管轄運輸支局・検査登録事務所は
                    <br v-if="isPC" />
                    <span class="red">
                      {{ syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_MEI }}
                    </span>
                    でお間違いないですか？
                  </p>
                  <p>異なる場合は右を選択</p>
                </th>
                <th v-else>
                  <p>
                    管轄運輸支局・検査登録事務所
                    <span class="must">必須</span>
                  </p>
                </th>
                <td>
                  <div ref="MEIHEN_UNYU_SIKYOKU_SHIKU_MEI" class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="MEIHEN_UNYU_SIKYOKU_SHIKU_CD"
                      >
                        <b-form-select
                          ref="MEIHEN_UNYU_SIKYOKU_SHIKU_CD"
                          v-model="syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_CD"
                          :state="errors.length ? false : null"
                          :options="rikujiList[Number(syaryo.MEIHEN_KEI_FLG)]"
                          trim
                          @change="setRikujiMeiAndCityCd"
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="!isLease">
                <th>登録種別</th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="MEIHEN_TOUROKU_KBN"
                      >
                        <b-form-select
                          ref="MEIHEN_TOUROKU_KBN"
                          v-model="syaryo.MEIHEN_TOUROKU_KBN"
                          :state="errors.length ? false : null"
                          :options="torokuKbnList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="!isLease">
                <th>ナンバー種別</th>
                <td>
                  <div class="row">
                    <div class="col-md-5 col-lg-3">
                      <validation-provider
                        v-slot="{ errors }"
                        ref="MEIHEN_NUMBER_KBN"
                      >
                        <b-form-select
                          ref="MEIHEN_NUMBER_KBN"
                          v-model="syaryo.MEIHEN_NUMBER_KBN"
                          :state="errors.length ? false : null"
                          :options="numberKbnList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>希望番号</th>
                <td>
                  <div class="ml-md-4">
                    <md-checkbox
                      ref="MEIHEN_KIBO_NUMBER_FLG"
                      class="form-check-input md-primary"
                      :true-value="1"
                      :false-value="0"
                      v-model.number="syaryo.MEIHEN_KIBO_NUMBER_FLG"
                    >
                      あり
                    </md-checkbox>
                  </div>
                  <p
                    v-if="!isLease && Number(syaryo.MEIHEN_KIBO_NUMBER_FLG)"
                    :class="['red f-size-14', { 'mt-3': !isMobile }]"
                  >
                    <br v-if="!isMobile" />
                    ※料金2,000円と別途ナンバー代ご請求
                  </p>
                </td>
              </tr>
              <tr v-if="Number(syaryo.MEIHEN_KIBO_NUMBER_FLG)">
                <th>希望番号の申請代行を希望しますか？</th>
                <td>
                  <div class="row">
                    <div class="col-md-3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="MEIHEN_KIBO_NUMBER_DAIKO_FLG"
                      >
                        <b-form-select
                          ref="MEIHEN_KIBO_NUMBER_DAIKO_FLG"
                          v-model="syaryo.MEIHEN_KIBO_NUMBER_DAIKO_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  Number(syaryo.MEIHEN_KIBO_NUMBER_FLG) &&
                  Number(syaryo.MEIHEN_KIBO_NUMBER_DAIKO_FLG)
                "
              >
                <th>
                  希望する番号
                  <span class="must">必須</span>
                  <p class="f-size-12">※ナンバー代は別途ご請求</p>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        name="MEIHEN_KIBO_NUMBER"
                        v-slot="{ errors }"
                        rules="required|max:4|numeric"
                      >
                        <b-form-input
                          ref="MEIHEN_KIBO_NUMBER"
                          v-model="syaryo.MEIHEN_KIBO_NUMBER"
                          maxlength="4"
                          :state="errors.length ? false : null"
                          placeholder="1234"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  Number(syaryo.MEIHEN_KIBO_NUMBER_FLG) &&
                  Number(syaryo.MEIHEN_KIBO_NUMBER_DAIKO_FLG)
                "
              >
                <th>
                  図柄入りナンバー
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="MEIHEN_KIBO_NUMBER_ZUGARA_FLG"
                      >
                        <b-form-select
                          ref="MEIHEN_KIBO_NUMBER_ZUGARA_FLG"
                          v-model="syaryo.MEIHEN_KIBO_NUMBER_ZUGARA_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoHopeList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  Number(syaryo.MEIHEN_KIBO_NUMBER_FLG) &&
                  !Number(syaryo.MEIHEN_KIBO_NUMBER_DAIKO_FLG)
                "
              >
                <th>
                  受付番号
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        name="MEIHEN_KIBO_NUMBER_UKETUKE_BANGO"
                        v-slot="{ errors }"
                        rules="required|max:7|numeric"
                      >
                        <b-form-input
                          ref="MEIHEN_KIBO_NUMBER_UKETUKE_BANGO"
                          v-model="syaryo.MEIHEN_KIBO_NUMBER_UKETUKE_BANGO"
                          maxlength="7"
                          :state="errors.length ? false : null"
                          placeholder="1234"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="!isLease">
                <th>課税対象</th>
                <td>
                  <div class="row">
                    <div class="col-md-7 col-lg-4">
                      <validation-provider
                        v-slot="{ errors }"
                        name="MEIHEN_KAZEI_KBN"
                      >
                        <b-form-select
                          ref="MEIHEN_KAZEI_KBN"
                          v-model="syaryo.MEIHEN_KAZEI_KBN"
                          :state="errors.length ? false : null"
                          :options="kazeiList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="!isLease">
                <th>
                  新所有者名
                  <span class="must">必須</span>
                </th>
                <td>
                  <validation-provider
                    name="MEIHEN_SYOYUSYA_MEI"
                    v-slot="{ errors }"
                    rules="required|max:20|char"
                  >
                    <b-form-input
                      ref="MEIHEN_SYOYUSYA_MEI"
                      class="col-md-8"
                      maxlength="20"
                      v-model="syaryo.MEIHEN_SYOYUSYA_MEI"
                      :state="errors.length ? false : null"
                      placeholder="株式会社○○"
                      trim
                      @blur="
                        syaryo.MEIHEN_SYOYUSYA_MEI = replaceChar(
                          syaryo.MEIHEN_SYOYUSYA_MEI
                        )
                      "
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
            </table>

            <new-user
              :is-get-data="isSinSiyosyaGetData"
              :is-set-data="isSinSiyosyaSetData"
              :observer="observer"
              :parent="syaryo"
              @setData="onSetSinSiyosya"
            />

            <table v-if="!isLease" class="table">
              <tr>
                <th>
                  車庫証明取得代行
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-7 col-lg-4">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="MEIHEN_SYAKOSYO_DAIKO_KBN"
                      >
                        <b-form-select
                          ref="MEIHEN_SYAKOSYO_DAIKO_KBN"
                          v-model="syaryo.MEIHEN_SYAKOSYO_DAIKO_KBN"
                          :state="errors.length ? false : null"
                          :options="syakoDaikoList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <p
                    v-if="
                      !isLease && Number(syaryo.MEIHEN_SYAKOSYO_DAIKO_KBN) > 1
                    "
                    class="mt-1 red f-size-14"
                  >
                    ※弊社で申請代行の場合は、料金{{
                      Number(syaryo.MEIHEN_KEI_FLG) ? '10,000' : '15,000'
                    }}円と別途印紙代ご請求
                  </p>
                </td>
              </tr>
              <tr>
                <th>
                  自賠責
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="row">
                    <div class="col-md-6 col-lg-4">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="MEIHEN_JIBAISEKI_KBN"
                      >
                        <b-form-select
                          ref="MEIHEN_JIBAISEKI_KBN"
                          v-model="syaryo.MEIHEN_JIBAISEKI_KBN"
                          :state="errors.length ? false : null"
                          :options="jibaisekiList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <p
                    v-if="!isLease && Number(syaryo.MEIHEN_JIBAISEKI_KBN) > 1"
                    class="mt-1 red f-size-14"
                  >
                    ※別途実費ご請求
                  </p>
                </td>
              </tr>
              <tr>
                <th>自動車税種別割額</th>
                <td>
                  <validation-provider
                    name="MEIHEN_JIDOSYA_ZEI"
                    v-slot="{ errors }"
                    rules="max:11|numeric"
                  >
                    <b-form-input
                      ref="MEIHEN_JIDOSYA_ZEI"
                      type="number"
                      class="col-md-3"
                      maxlength="11"
                      v-model="syaryo.MEIHEN_JIDOSYA_ZEI"
                      :state="errors.length ? false : null"
                      placeholder="10,000"
                      trim
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
              <tr>
                <th>環境性能割額</th>
                <td>
                  <validation-provider
                    name="MEIHEN_JIDOSYA_SYUTOKU_ZEI"
                    v-slot="{ errors }"
                    rules="max:11|numeric"
                  >
                    <b-form-input
                      ref="MEIHEN_JIDOSYA_SYUTOKU_ZEI"
                      type="number"
                      class="col-md-3"
                      maxlength="11"
                      v-model="syaryo.MEIHEN_JIDOSYA_SYUTOKU_ZEI"
                      :state="errors.length ? false : null"
                      placeholder="10,000"
                      trim
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
              <tr>
                <th>重量税額</th>
                <td>
                  <validation-provider
                    name="MEIHEN_JYURYOU_ZEI"
                    v-slot="{ errors }"
                    rules="max:11|numeric"
                  >
                    <b-form-input
                      ref="MEIHEN_JYURYOU_ZEI"
                      type="number"
                      class="col-md-3"
                      maxlength="11"
                      v-model="syaryo.MEIHEN_JYURYOU_ZEI"
                      :state="errors.length ? false : null"
                      placeholder="10,000"
                      trim
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
            </table>
          </section>
        </div>

        <h4 class="page-sub-title pl-2 pl-md-4 mt-5">その他</h4>
        <div class="section-wrapper">
          <section class="order-biko">
            <h5 class="_page-sub-title pl-2 pl-md-4">車両備考</h5>
            <table class="table">
              <tr>
                <th>備考</th>
                <td>
                  <validation-provider
                    name="BIKO"
                    v-slot="{ errors }"
                    rules="max:30|char"
                  >
                    <b-form-textarea
                      ref="BIKO"
                      maxlength="30"
                      v-model="syaryo.BIKO"
                      :state="errors.length ? false : null"
                      trim
                      @blur="syaryo.BIKO = replaceChar(syaryo.BIKO)"
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
            </table>
            <div class="text-right sp-fs-12">
              {{ syaryo.BIKO ? syaryo.BIKO.length : 0 }}/30
            </div>
          </section>
        </div>

        <h4 class="page-sub-title pl-2 pl-md-4 mt-5">オプション</h4>
        <div class="section-wrapper">
          <section class="order-option">
            <h5 class="_page-sub-title pl-2 pl-md-4">ETC車載器</h5>
            <table class="table">
              <tr>
                <th>ETC車載器セットアップのご希望</th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="ETC_SETUP_FLG"
                      >
                        <b-form-select
                          ref="ETC_SETUP_FLG"
                          v-model="syaryo.ETC_SETUP_FLG"
                          :state="errors.length ? false : null"
                          :options="etcHopeList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <p
                    v-if="!isLease && Number(syaryo.ETC_SETUP_FLG)"
                    class="mt-2 red f-size-14"
                  >
                    ※料金5,000円と別途実費ご請求
                  </p>
                </td>
              </tr>
              <tr v-if="Number(syaryo.ETC_SETUP_FLG)">
                <th>
                  ETC車載器管理番号
                  <span v-if="!isLease" class="must">必須</span>
                </th>
                <td>
                  <validation-provider
                    name="ETC_KANRI_BANGO"
                    v-slot="{ errors }"
                    :rules="`${!isLease ? 'required|' : ''}max:20|char`"
                  >
                    <b-form-input
                      ref="ETC_KANRI_BANGO"
                      v-model="syaryo.ETC_KANRI_BANGO"
                      class="col-md-4"
                      maxlength="20"
                      :state="errors.length ? false : null"
                      placeholder="00000-00000000-0000000"
                      trim
                      @blur="
                        syaryo.ETC_KANRI_BANGO = replaceChar(
                          syaryo.ETC_KANRI_BANGO
                        )
                      "
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
              <tr v-if="Number(syaryo.ETC_SETUP_FLG)">
                <th>
                  ETC型式登録番号
                  <span v-if="!isLease" class="must">必須</span>
                </th>
                <td>
                  <validation-provider
                    name="ETC_TOUROKU_BANGO"
                    v-slot="{ errors }"
                    :rules="`${!isLease ? 'required|' : ''}max:20|char`"
                  >
                    <b-form-input
                      ref="ETC_TOUROKU_BANGO"
                      v-model="syaryo.ETC_TOUROKU_BANGO"
                      class="col-md-3"
                      maxlength="20"
                      :state="errors.length ? false : null"
                      placeholder="0000"
                      trim
                      @blur="
                        syaryo.ETC_TOUROKU_BANGO = replaceChar(
                          syaryo.ETC_TOUROKU_BANGO
                        )
                      "
                    />
                    <b-form-invalid-feedback>
                      <span class="border-red">{{ errors[0] }}</span>
                    </b-form-invalid-feedback>
                  </validation-provider>
                </td>
              </tr>
            </table>

            <h5 v-if="isLease" class="page-sub-title pl-2 pl-md-4 mt-3 mt-md-4">
              車庫証明申請受領
            </h5>
            <table v-if="isLease" class="table">
              <tr>
                <th>車庫証明申請受領のご希望</th>
                <td>
                  <div class="row">
                    <div class="col-md-3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="SYAKOSYO_JYURYO_FLG"
                      >
                        <b-form-select
                          ref="SYAKOSYO_JYURYO_FLG"
                          v-model="syaryo.SYAKOSYO_JYURYO_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoHopeList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="Number(syaryo.SYAKOSYO_JYURYO_FLG)">
                <th>
                  車庫証明申請書類
                  <span class="must">必須</span>
                </th>
                <td>
                  <div class="form-check form-check-inline">
                    <input
                      ref="SYAKOSYO_JYURYO_KBN"
                      class="form-check-input"
                      type="radio"
                      id="option-jyuryo-flg-1"
                      value="1"
                      v-model="syaryo.SYAKOSYO_JYURYO_KBN"
                    />
                    <label class="form-check-label" for="option-jyuryo-flg-1">
                      書類回収済み
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      ref="SYAKOSYO_JYURYO_KBN"
                      class="form-check-input"
                      type="radio"
                      id="option-jyuryo-flg-2"
                      value="2"
                      v-model="syaryo.SYAKOSYO_JYURYO_KBN"
                    />
                    <label class="form-check-label" for="option-jyuryo-flg-2">
                      <span v-if="isLease">使用者</span>
                      <span v-else>ユーザー</span>
                      から書類回収希望
                    </label>
                  </div>
                </td>
              </tr>
            </table>

            <h5 class="page-sub-title pl-2 pl-md-4 mt-3 mt-md-4">
              清掃サービス
            </h5>
            <table class="table">
              <tr>
                <th>清掃サービス</th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="SEISOU_FLG"
                      >
                        <b-form-select
                          ref="SEISOU_FLG"
                          v-model="syaryo.SEISOU_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoHopeList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <p v-if="syaryo.SEISOU_FLG" class="mt-2 red f-size-14">
                    ※別途実費ご請求
                  </p>
                </td>
              </tr>
              <tr v-if="Number(syaryo.SEISOU_FLG)">
                <th>
                  清掃内容
                  <span class="must">必須</span>
                </th>
                <td>
                  <div v-if="!isLease" class="p-1">
                    <div class="form-check form-check-inline col-md-12 py-1">
                      <input
                        ref="SEISOU_KBN"
                        class="form-check-input"
                        type="radio"
                        id="seisou-flg-5"
                        value="2"
                        v-model="syaryo.SEISOU_KBN"
                      />
                      <label class="form-check-label" for="seisou-flg-5">
                        手洗い
                      </label>
                    </div>
                    <div class="form-check form-check-inline col-md-12 py-1">
                      <input
                        ref="SEISOU_KBN"
                        class="form-check-input"
                        type="radio"
                        id="seisou-flg-6"
                        value="1"
                        v-model="syaryo.SEISOU_KBN"
                      />
                      <label class="form-check-label" for="seisou-flg-6">
                        洗車機
                      </label>
                    </div>
                  </div>
                  <div v-else class="p-1">
                    <div
                      v-if="Number(syaryo.SYARYO_TYPE_KBN) === 1"
                      class="form-check form-check-inline col-md-12 py-1"
                    >
                      <input
                        ref="SEISOU_KBN"
                        class="form-check-input"
                        type="radio"
                        id="seisou-flg-3"
                        value="10"
                        v-model="syaryo.SEISOU_KBN"
                      />
                      <label class="form-check-label" for="seisou-flg-3">
                        スタンド立寄り洗車（簡易車外と室内）
                      </label>
                    </div>
                    <div
                      v-if="Number(syaryo.SYARYO_TYPE_KBN) === 1"
                      class="form-check form-check-inline col-md-12 py-1"
                    >
                      <input
                        ref="SEISOU_KBN"
                        class="form-check-input"
                        type="radio"
                        id="seisou-flg-4"
                        value="11"
                        v-model="syaryo.SEISOU_KBN"
                      />
                      <label class="form-check-label" for="seisou-flg-4">
                        ヤード内での洗車（車外・室内）
                      </label>
                    </div>
                    <div class="form-check form-check-inline col-md-12 py-1">
                      <input
                        ref="SEISOU_KBN"
                        class="form-check-input"
                        type="radio"
                        id="seisou-flg-5"
                        value="12"
                        v-model="syaryo.SEISOU_KBN"
                      />
                      <label class="form-check-label" for="seisou-flg-5">
                        室内清掃（ダスキン標準） 15,000円～
                      </label>
                    </div>
                    <div class="form-check form-check-inline col-md-12 py-1">
                      <input
                        ref="SEISOU_KBN"
                        class="form-check-input"
                        type="radio"
                        id="seisou-flg-6"
                        value="13"
                        v-model="syaryo.SEISOU_KBN"
                      />
                      <label class="form-check-label" for="seisou-flg-6">
                        室内清掃（ダスキンスペシャル） 28,000円～
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
            </table>

            <h5 class="page-sub-title pl-2 pl-md-4 mt-3 mt-md-4">保管</h5>
            <table class="table">
              <tr>
                <th>保管のご希望</th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider name="HOKAN_FLG" v-slot="{ errors }">
                        <b-form-select
                          ref="HOKAN_FLG"
                          v-model="syaryo.HOKAN_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoHopeList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
            </table>

            <garage-consent
              v-if="isLease"
              :is-get-data="isSyakoSyodakusyoGetData"
              :is-set-data="isSyakoSyodakusyoSetData"
              :observer="observer"
              :parent="syaryo"
              @setData="onSetSyakoSyodakusyo"
            />

            <resident
              ref="resident"
              v-if="isLease"
              :is-get-data="isJyuminhyoGetData"
              :is-set-data="isJyuminhyoSetData"
              :observer="observer"
              :parent="syaryo"
              @setData="onSetJyuminhyo"
            />

            <h5 v-if="isLease" class="page-sub-title pl-2 pl-md-4 mt-3 mt-md-4">
              車検証再発行
            </h5>
            <table v-if="isLease" class="table">
              <tr>
                <th>車検証再発行のご希望</th>
                <td>
                  <div class="row">
                    <div class="col-md-4 col-lg-3">
                      <validation-provider
                        name="SYAKENSYO_SAIHAKKO_FLG"
                        v-slot="{ errors }"
                      >
                        <b-form-select
                          ref="SYAKENSYO_SAIHAKKO_FLG"
                          v-model="syaryo.SYAKENSYO_SAIHAKKO_FLG"
                          :state="errors.length ? false : null"
                          :options="yesNoHopeList"
                          trim
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </td>
              </tr>
            </table>

            <h5 class="page-sub-title pl-2 pl-md-4 mt-3 mt-md-4">ご要望</h5>
            <table class="table">
              <tr>
                <th>その他ご要望</th>
                <td>
                  <div>
                    <validation-provider
                      name="YOUBOU"
                      v-slot="{ errors }"
                      rules="max:200|char"
                    >
                      <b-form-textarea
                        ref="YOUBOU"
                        v-model="syaryo.YOUBOU"
                        :state="errors.length ? false : null"
                        trim
                        maxlength="200"
                        @blur="syaryo.YOUBOU = replaceChar(syaryo.YOUBOU)"
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                </td>
              </tr>
            </table>
            <div class="text-right sp-fs-12">
              {{ syaryo.YOUBOU ? syaryo.YOUBOU.length : 0 }}/200
            </div>
          </section>
        </div>
      </validation-observer>

      <div v-if="isEnableInvoice">
        <h4 class="page-sub-title pl-2 pl-md-4 mt-5">請求先</h4>
        <invoice
          :is-invoice-valid-active="isInvoiceValidActive"
          :parent-form="form"
          @setIsInvoiceValid="setIsInvoiceValid"
          @setIsInvoiceValidActive="setIsInvoiceValidActive"
          @setInvoice="setInvoice"
        />
      </div>

      <div class="text-center mt-5 mr-3 mr-md-0">
        <md-button
          type="button"
          class="btn-lg btn-secondary base-btn col-md-3 col-lg-2"
          @click="back()"
        >
          もどる
        </md-button>
        <br v-if="isMobile" />
        <md-button
          type="submit"
          class="md-raised btn-lg btn-success base-btn col-md-3 col-lg-2"
          :disabled="isSubmitDisabled"
          @click="next"
        >
          次へ
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import Invoice from '@/components/order/invoice/Invoice'
import GarageConsent from '@/components/order/meihen/GarageConsent'
import NewUser from '@/components/order/meihen/NewUser'
import Resident from '@/components/order/meihen/Resident'
import Constant from '@/const'
import cloneDeep from 'lodash/cloneDeep'
import merge from 'lodash/merge'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'; // Optional CSS
import vue2Dropzone from 'vue2-dropzone'
import Mixin from '../../mixin/Mixin'
import Navi from '../Navi'
let _this

export default {
  name: 'VehicleMeihen',
  mixins: [Mixin],
  components: {
    Navi,
    vueDropzone: vue2Dropzone,
    VueSimpleSuggest,
    Invoice,
    NewUser,
    Resident,
    GarageConsent,
  },
  data: () => ({
    /** オブザーバー */
    observer: null,

    /** 請求先バリデーション発火フラグ **/
    isInvoiceValidActive: false,

    /** 請求先バリデーション結果 **/
    isInvoiceValid: false,

    // サジェスト設定
    autoCompleteStyle: {
      vueSimpleSuggest: 'position-relative',
      inputWrapper: '',
      defaultInput: 'form-control',
      suggestions: 'position-absolute list-group z-1000',
      suggestItem: 'list-group-item',
    },
    autoCompleteStyleError: {
      vueSimpleSuggest: 'position-relative',
      inputWrapper: '',
      defaultInput: 'form-control border-red',
      suggestions: 'position-absolute list-group z-1000',
      suggestItem: 'list-group-item',
    },
    rikujiList: [], // 陸自リスト
    rikujiFullList: [], // 陸自全リスト
    makerList: [], // 車両メーカ一覧
    syameiList: [], // 車名一覧
    shitadoriSyameiList: [], // 下取車名一覧
    makerSyameiMap: {}, // メーカー、車名マップ
    idUploaded: false,

    /** 次へボタンのdisabledフラグ */
    isSubmitDisabled: false,

    // 搬出券
    dropzoneOptions: {
      url: `${process.env.API.DOMAIN}${Constant.API_URL.IMAGES_ORDER}`,
      thumbnailWidth: 150,
      maxFilesize: 5,
      maxFiles: 1,
      headers: { 'My-Awesome-Header': 'header value' },
      addRemoveLinks: true,
      dictCancelUpload: 'キャンセル',
      dictRemoveFile: 'キャンセル',
      error: function (file) {
        this.removeFile(file)
        _this.spinerOff()
        _this.scroll('clear')
        _this._alert('5MB以下のファイルを1ファイルのみご利用ください', false)
      },
      dictDefaultMessage:
        "<i class='fa fa-cloud-upload'></i>ファイルを選択してください",
    },

    // その他ファイル
    dropzoneOtherOptions: {
      url: `${process.env.API.DOMAIN}${Constant.API_URL.IMAGES_ORDER_OTHER}`,
      thumbnailWidth: 150,
      maxFilesize: 5, //MB
      maxFiles: 5, // ファイル上限数
      headers: { 'My-Awesome-Header': 'header value' },
      addRemoveLinks: true,
      dictCancelUpload: 'キャンセル',
      dictRemoveFile: 'キャンセル',
      error: function (file) {
        _this.removeOtherFile(file)
        _this.spinerOff()
        _this.scroll('clear')
        _this._alert('5MB以下のファイルを5ファイル以下でご利用ください', false)
      },
      dictDefaultMessage:
        "<i class='fa fa-cloud-upload'></i>ファイルを選択してください",
    },

    numberArea: [], // 登録地域
    form: {}, // 引納データ
    syaryo: {}, // 車両データ
    vehicles: [], // 車両リスト表示用データ
    vehicleID: 0, // 車両リスト表示用データID
    transports: [],
    syaryoDefault: {
      MEISAI_BANGO: null,
      SYARYO_STATUS: 0,
      SHITADORI_FLG: 0,
      YUSOSAKI_KBN: 2,
      YUSOSAKI_FREE: null,
      SOUFUBUTU_KBN: 0,
      SYARYO_TYPE_KBN: '',
      SYAKEN_FLG: 0,
      SYARYO_MAKER_MEI: '',
      SYARYO_MEI: '',
      SYADAI_BANGO: null,
      TOUROKU_BANGO: null,
      SHITADORI_SYARYO_TYPE_KBN: '',
      SHITADORI_SYAKEN_FLG: 0,
      SHITADORI_SYARYO_MAKER_MEI: '',
      SHITADORI_SYARYO_MEI: '',
      SHITADORI_SYADAI_BANGO: null,
      SHITADORI_TOUROKU_BANGO: null,
      SYARYO_NAGASA: null,
      SYARYO_HABA: null,
      SYARYO_TAKASA: null,
      KISYA_KANRI_BANGO: null,
      SYUPPIN_BANGO: null,
      HANSYUTUKEN_URL: '',
      OTHER_FILE_LIST: [],
      HANNYU_MEI: null,
      ATSUKAI_MEI: null,
      MUKETI_MEI: null,
      JISOU_KBN: 1,
      JYOTAI_FLG: 0,
      MEIHEN_KIBO_BI: null,
      MEIHEN_SYAKEN_KBN: 1,
      MEIHEN_KEI_FLG: 0,
      MEIHEN_UNYU_SIKYOKU_TODO_MEI: null,
      MEIHEN_UNYU_SIKYOKU_SHIKU_MEI: null,
      MEIHEN_UNYU_SIKYOKU_SHIKU_CD: '',
      MEIHEN_TOUROKU_KBN: 4,
      MEIHEN_NUMBER_KBN: '',
      MEIHEN_KIBO_NUMBER_FLG: 0,
      MEIHEN_KIBO_NUMBER_DAIKO_FLG: 0,
      MEIHEN_KIBO_NUMBER: null,
      MEIHEN_KIBO_NUMBER_ZUGARA_FLG: 0,
      MEIHEN_KIBO_NUMBER_UKETUKE_BANGO: null,
      MEIHEN_KAZEI_KBN: '',
      MEIHEN_SYOYUSYA_MEI: null,
      MEIHEN_SIYOSYA_MEI: null,
      MEIHEN_SIYOSYA_MEI_KANA: null,
      MEIHEN_SIYOSYA_YUBIN1: null,
      MEIHEN_SIYOSYA_YUBIN2: null,
      MEIHEN_SIYOSYA_TODO_CD: null,
      MEIHEN_SIYOSYA_TODO_MEI: null,
      MEIHEN_SIYOSYA_SHIKU_CD: '',
      MEIHEN_SIYOSYA_SHIKU_MEI: null,
      MEIHEN_SIYOSYA_BANCHI: null,
      MEIHEN_SIYOSYA_TEL: null,
      MEIHEN_SIYOSYA_MAIL_ADDR: null,
      MEIHEN_SYAKOSYO_DAIKO_KBN: 1,
      MEIHEN_JIBAISEKI_KBN: '',
      MEIHEN_JIDOSYA_ZEI: null,
      MEIHEN_JIDOSYA_SYUTOKU_ZEI: null,
      MEIHEN_JYURYOU_ZEI: null,
      JYUMINHYO_FLG: 0,
      JYUMINHYO_YUBIN1: null,
      JYUMINHYO_YUBIN2: null,
      JYUMINHYO_TODO_CD: null,
      JYUMINHYO_TODO_MEI: null,
      JYUMINHYO_SHIKU_CD: '',
      JYUMINHYO_SHIKU_MEI: null,
      JYUMINHYO_BANCHI: null,
      HANSYUTUKEN: null,
      BIKO: null,
      ETC_SETUP_FLG: 0,
      ETC_KANRI_BANGO: null,
      ETC_TOUROKU_BANGO: null,
      SYAKOSYO_JYURYO_FLG: null,
      SYAKOSYO_JYURYO_KBN: null,
      SEISOU_FLG: 0,
      SEISOU_KBN: '2',
      HOKAN_FLG: 0,
      JYUMINHYO_DAIKO_FLG: 0,
      JYUMINHYO_DAIKO_YEAR: null,
      JYUMINHYO_DAIKO_MONTH: null,
      JYUMINHYO_DAIKO_DAY: null,
      SYAKENSYO_SAIHAKKO_FLG: 0,
      SYAKO_SYODAKUSYO_FLG: 0,
      SYAKO_SYODAKUSYO_TORIYOSE_FLG: 0,
      SYAKO_SYODAKUSYO_TORIYOSE: null,
      SYAKO_SYODAKUSYO_CHUSYAJYO_KEIYAKU_MEI: null,
      SYAKO_SYODAKUSYO_CHUSYAJYO_MEI: null,
      SYAKO_SYODAKUSYO_CHUSYAJYO_BANGO: null,
      SYAKO_SYODAKUSYO_YUBIN1: null,
      SYAKO_SYODAKUSYO_YUBIN2: null,
      SYAKO_SYODAKUSYO_TODO_CD: null,
      SYAKO_SYODAKUSYO_TODO_MEI: null,
      SYAKO_SYODAKUSYO_SHIKU_CD: '',
      SYAKO_SYODAKUSYO_SHIKU_MEI: null,
      SYAKO_SYODAKUSYO_BANCHI: null,
      SYAKO_SYODAKUSYO_TEL: null,
      YOUBOU: null,
      NUMBER_PLATE_FLG: null,
      NUMBER_PLATE_MEI: null,
      NUMBER_PLATE_YUBIN1: null,
      NUMBER_PLATE_YUBIN2: null,
      NUMBER_PLATE_TODO_CD: null,
      NUMBER_PLATE_TODO_MEI: null,
      NUMBER_PLATE_SHIKU_CD: null,
      NUMBER_PLATE_SHIKU_MEI: null,
      NUMBER_PLATE_BANCHI: null,
      NUMBER_PLATE_SAKI_TEL: null,
      IREKAE_FLG: null,
      torokubango1: '',
      torokubango2: null,
      torokubango3: null,
      torokubango4: null,
      shitadoriTorokubango1: '',
      shitadoriTorokubango2: null,
      shitadoriTorokubango3: null,
      shitadoriTorokubango4: null,
    },
    option: {},

    /** 新使用者入力データ */
    sinSiyosya: null,

    /** 新使用者入力データ取得フラグ */
    isSinSiyosyaGetData: false,

    /** 新使用者入力データ設定フラグ */
    isSinSiyosyaSetData: false,

    /** 住民票入力データ */
    jyuminhyo: null,

    /** 住民票入力データ取得フラグ */
    isJyuminhyoGetData: false,

    /** 住民票入力データ設定フラグ */
    isJyuminhyoSetData: false,

    /** 車庫承諾書入力データ */
    syakoSyodakusyo: null,

    /** 車庫承諾書入力データ取得フラグ */
    isSyakoSyodakusyoGetData: false,

    /** 車庫承諾書入力データ設定フラグ */
    isSyakoSyodakusyoSetData: false,
  }),

  methods: {
    /** 車両に有効な入力データのみ設定する */
    cleanupSyaryo(syaryo) {
      let d = {}
      for (var name in this.syaryoDefault) {
        if (this.$refs[name]) d[name] = syaryo[name]
        else delete d[name]
      }
      if (syaryo.ID) d['ID'] = syaryo.ID
      if (syaryo.IRAI_JYUCHU_ID) d['IRAI_JYUCHU_ID'] = syaryo.IRAI_JYUCHU_ID
      if (syaryo.isMitumori) d['isMitumori'] = syaryo.isMitumori
      return d
    },

    /** オプションに有効な入力データのみ設定する */
    cleanupOption(syaryo) {
      const nameList = [
        'ETC_SETUP_FLG',
        'ETC_KANRI_BANGO',
        'ETC_TOUROKU_BANGO',
        'SYAKOSYO_JYURYO_FLG',
        'SYAKOSYO_JYURYO_KBN',
        'SEISOU_FLG',
        'SEISOU_KBN',
        'HOKAN_FLG',
        'YOUBOU',
      ]
      let d = {}
      nameList
        .filter((name) => this.$refs[name])
        .map((name) => (d[name] = syaryo[name]))
      return d
    },

    // 戻る
    back() {
      this.form.syaryos = [this.syaryo]
      const params = {
        yusoKbn: this.form.MEIHEN_FLG,
        form: this.form,
      }
      this.$router.push({ name: 'OrderMeihenTransport', params })
    },

    /** 確認画面に渡すデータを生成する */
    async makeConfirmData() {
      let syaryo = this.cleanupSyaryo(this.syaryo)
      let option = this.cleanupOption(syaryo)
      this.isSinSiyosyaGetData = true
      this.isJyuminhyoGetData = true
      this.isSyakoSyodakusyoGetData = true
      await this.sleep(50)
      syaryo.id = this.vehicleID
      if (this.sinSiyosya) merge(syaryo, this.sinSiyosya)
      if (this.jyuminhyo) {
        merge(syaryo, this.jyuminhyo)
        merge(option, this.jyuminhyo)
      }
      if (this.syakoSyodakusyo) {
        merge(syaryo, this.syakoSyodakusyo)
        merge(option, this.syakoSyodakusyo)
      }
      this.form.syaryos = [syaryo]
      this.form.option = option
    },

    /** 確認画面へ */
    async next() {
      this.isSubmitDisabled = true
      this.spinerOff()

      let isSuccess = true
      if (this.isEnableInvoice) {
        // バリデーション実行
        this.isInvoiceValidActive = true
        isSuccess = await this.observer.validate()
        await this.sleep(100)
      } else {
        // 請求不可能な取引先は請求バリデーションフラグをtrueにする
        this.isInvoiceValid = true
      }

      if (!(this.isInvoiceValid && isSuccess)) {
        this._alert('入力項目にエラーがあります。')
        this.isSubmitDisabled = false
        return
      }

      await this.makeConfirmData()
      this.form.isNosyaYard = this.isNosyaYard
      this.isSubmitDisabled = false
      this.$router.push({
        name: 'OrderMeihenConfirm',
        params: { form: this.form },
      })
    },

    /**
     * 請求先バリデーション発火フラグをセットする
     * @param Boolean isInvoiceValid
     */
    setIsInvoiceValidActive(isActive) {
      this.isInvoiceValidActive = isActive
    },
    /**
     * 請求先バリデーション結果フラグをセットする
     * @param Boolean isInvoiceValid
     */
    setIsInvoiceValid(isValid) {
      this.isInvoiceValid = isValid
    },

    /**
     * formデータをマージする
     * @param form form
     */
    setInvoice(form) {
      this.form = merge(this.form, form)
    },

    // データ初期化
    async setDefaultData() {
      // 搬出券
      if (
        this.$refs.HANSYUTUKEN_URL !== undefined &&
        this.$refs.HANSYUTUKEN_URL.dropzone.files.length > 0
      ) {
        this.$refs.HANSYUTUKEN_URL.removeAllFiles()
      }

      // その他ファイル
      if (
        this.$refs.OTHER_FILE_LIST !== undefined &&
        this.$refs.OTHER_FILE_LIST.dropzone.files.length > 0
      ) {
        this.$refs.OTHER_FILE_LIST.removeAllFiles()
      }

      this.syaryo = cloneDeep(this.syaryoDefault)
    },

    /** 登録番号設定 */
    async onChangeTorokubango() {
      await this.observer.refs.torokubango1.validate()
      await this.observer.refs.torokubango2.validate()
      await this.observer.refs.torokubango3.validate()
      await this.observer.refs.torokubango4.validate()
      if (!this.isInvalidTorokuBnago)
        this.syaryo.TOUROKU_BANGO = `${this.syaryo.torokubango1} ${this.syaryo.torokubango2} ${this.syaryo.torokubango3} ${this.syaryo.torokubango4}`
      else this.syaryo.TOUROKU_BANGO = ''
    },

    /** 下取登録番号設定 */
    async onShitadoriChangeTorokubango() {
      await this.observer.refs.shitadoriTorokubango1.validate()
      await this.observer.refs.shitadoriTorokubango2.validate()
      await this.observer.refs.shitadoriTorokubango3.validate()
      await this.observer.refs.shitadoriTorokubango4.validate()
      if (!this.isInvalidShitadoriTorokuBnago)
        this.syaryo.SHITADORI_TOUROKU_BANGO = `${this.syaryo.shitadoriTorokubango1} ${this.syaryo.shitadoriTorokubango2} ${this.syaryo.shitadoriTorokubango3} ${this.syaryo.shitadoriTorokubango4}`
      else this.syaryo.SHITADORI_TOUROKU_BANGO = ''
    },

    /** 登録地域取得 */
    setNumberArea() {
      this.getNumberArea().then((res) => {
        this.numberArea = res.data.map((v) => {
          return {
            value: v.NUMBER_CHIMEI,
            text: v.NUMBER_CHIMEI,
          }
        })
        this.numberArea.unshift({
          value: '',
          text: '未選択',
        })
      })
    },

    // 引取で選択したタブ名取得
    getHikitoriTabName() {
      return this.form.ACTIVE_HIKITORI_TAB
    },
    // 納車で選択したタブ名取得
    getNosyaTabName() {
      return this.form.ACTIVE_NOSYA_TAB
    },
    // メーカー一覧、車名マップのサジェストデータセット
    setSyaryoMaker() {
      this.getSyaryoMakerList()
        .then((res) => {
          for (const item of res.data) {
            this.makerList.push(item.MAKER_MEI)
            const list = []
            for (const item2 of item.kensaku_syamei) {
              list.push(item2.SYAMEI)
            }
            this.makerSyameiMap[item.MAKER_MEI] = list
          }
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 車名一覧データ設定
    setSyameiList() {
      this.syameiList = []
      // 普通車の場合のみ車名サジェストを行う
      const syaryoType = this.syaryo.SYARYO_TYPE_KBN
      if (Number(syaryoType) === 1) {
        const maker = this.syaryo.SYARYO_MAKER_MEI
        this.syameiList = this.makerSyameiMap[maker] || []
      }
    },
    // 下取車名一覧データ設定
    setShitadoriSyameiList() {
      this.shitadoriSyameiList = []
      // 普通車の場合のみ車名サジェストを行う
      const syaryoType = this.syaryo.SHITADORI_SYARYO_TYPE_KBN
      if (Number(syaryoType) === 1) {
        const maker = this.syaryo.SHITADORI_SYARYO_MAKER_MEI
        this.shitadoriSyameiList = this.makerSyameiMap[maker] || []
      }
    },

    ////// 搬出券 ///////////
    vfileSend() {
      this.spinerOn()
    },
    /** アップロード完了時にURLを格納する */
    vfilesent(file) {
      this.spinerOff()
      this.scroll('clear')
      this.syaryo.HANSYUTUKEN_URL = file.xhr.response
      this.syaryo.HANSYUTUKEN = file
    },
    removeFile(file) {
      this.syaryo.HANSYUTUKEN_URL = ''
    },
    /////////////////////////

    ////// その他ファイル /////
    vfileOtherSend() {
      this.spinerOn()
    },
    /** アップロード完了時にURLを格納する */
    vfileOtherSent(file) {
      this.spinerOff()
      this.scroll('clear')
      this.syaryo.OTHER_FILE_LIST.push(file)
    },
    removeOtherFile(file) {
      this.syaryo.OTHER_FILE_LIST = this.syaryo.OTHER_FILE_LIST.filter(
        (v) => v.xhr.response !== file.xhr.response
      )
    },
    addedOtherFile(file) {
      const conds = [
        'image/jpeg',
        'image/png',
        'application/pdf',
        'image/gif',
        'image/bmp',
      ]
      if (!conds.includes(file.type)) {
        this._alert(
          '.jpg .bmp .gif .pdf .pngのファイルをアップしてください',
          false
        )
        this.$refs.OTHER_FILE_LIST.removeFile(file)
      }
    },
    /////////////////////////

    // 陸自名称,市区町村CDを設定
    setRikujiMeiAndCityCd() {
      if (this.isLease) return
      const list = this.rikujiList[Number(this.syaryo.MEIHEN_KEI_FLG)]

      // 見積からきた場合
      if (this.syaryo.RIKUJI_MEI) {
        const rikuji = this.getParam(list, this.syaryo.RIKUJI_MEI, 'text')
        if (rikuji) {
          this.syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_CD = rikuji.value
          this.syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_MEI = rikuji.text
        }
        this.syaryo.RIKUJI_MEI = null
        return
      }

      const shikuCd = this.syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_CD
      this.syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_MEI = null
      for (const item of list) {
        if (item.value === shikuCd) {
          this.syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_MEI = item.text
          break
        }
      }

      if (!this.syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_MEI) {
        const rikuji = this.getRikujiDefault(
          this.rikujiFullList[Number(this.syaryo.MEIHEN_KEI_FLG)],
          this.nosya.TODO_MEI,
          this.nosya.SHIKU_MEI
        )
        this.syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_CD = rikuji.SHIKU_CD
        this.syaryo.MEIHEN_UNYU_SIKYOKU_SHIKU_MEI = rikuji.RIKUJI_RYAKUSYO
      }
    },

    /** 管轄運輸支局データ設定 */
    async setRikujiList() {
      await this.getRikujiList()
        .then((res) => {
          this.rikujiFullList = res.data
          const list1 = res.data[0].map((v) => {
            return {
              text: v.RIKUJI_RYAKUSYO,
              value: v.SHIKU_CD,
            }
          })
          const list2 = res.data[1].map((v) => {
            return {
              text: v.RIKUJI_RYAKUSYO,
              value: v.SHIKU_CD,
            }
          })
          list1.unshift({
            text: '未選択',
            value: '',
          })
          list2.unshift({
            text: '未選択',
            value: '',
          })
          this.rikujiList.push(list1)
          this.rikujiList.push(list2)
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },

    async setLastJyucyu() {
      return this.getLastJyucyu({ MEIHEN_FLG: this.form.MEIHEN_FLG })
    },

    addFileToS3() {
      const add = (file, dropRef) => {
        dropRef.manuallyAddFile(file)
        if (!file.type.match(/pdf/)) {
          dropRef.dropzone.emit('thumbnail', file, file.dataURL)
        }
        dropRef.dropzone.emit('complete', file)
      }

      const dropRef = null

      // 搬出券
      if (this.syaryo.HANSYUTUKEN_URL) {
        const dropRef = this.$refs.HANSYUTUKEN_URL
        add(this.syaryo.HANSYUTUKEN, dropRef)
      }

      // その他ファイル
      if (this.syaryo.OTHER_FILE_LIST.length > 0) {
        const dropRef = this.$refs.OTHER_FILE_LIST
        this.syaryo.OTHER_FILE_LIST.forEach((file) => add(file, dropRef))
      }
    },

    // デフォルト値設定
    async makeDefaultData() {
      const d = this.syaryoDefault

      if (this.isNosyaHokanYard) {
        d.HOKAN_FLG = 1
      }

      if (this.isLease) {
        d.YUSOSAKI_KBN = 3
        d.SYAKOSYO_JYURYO_FLG = 0
        d.SYAKOSYO_JYURYO_KBN = '1'
        d.SEISOU_KBN = '12'
      }

      // 前回入力値
      const results = []
      results.push(
        this.setLastJyucyu().then((res) => {
          const d = res.data
          if (d) {
            if (this.isNosyaYard) {
              d.HANNYU_MEI = d.HANNYU_MEI
              d.ATSUKAI_MEI = d.ATSUKAI_MEI
            }
            if (d.MEIHEN_TOUROKU_KBN) {
              d.MEIHEN_TOUROKU_KBN = d.MEIHEN_TOUROKU_KBN
            }
          }
        })
      )

      // 陸自
      results.push(
        this.setRikujiList().then((res) => {
          if (this.form.ACTIVE_NOSYA_TAB === 'DIRECT') {
            d.MEIHEN_UNYU_SIKYOKU_SHIKU_CD = this.form.NOSYA_DIRECT.SHIKU_CD
          } else if (this.form.ACTIVE_NOSYA_TAB === 'MASTER') {
            d.MEIHEN_UNYU_SIKYOKU_SHIKU_CD = this.form.NOSYA_MASTER.SHIKU_CD
          } else if (this.form.ACTIVE_NOSYA_TAB === 'FAVORITE') {
            d.MEIHEN_UNYU_SIKYOKU_SHIKU_CD = this.form.NOSYA_FAVORITE.SHIKU_CD
          }
        })
      )

      await Promise.all(results)
    },

    /** デフォルト車両と指定車両をマージする */
    syaryoDefaultMerge(syaryo) {
      let d = {}
      for (const name in syaryo) {
        if (syaryo[name] !== null) d[name] = syaryo[name]
        else d[name] = this.syaryoDefault[name]
      }
      for (const name in this.syaryoDefault) {
        if (syaryo[name] === undefined) d[name] = this.syaryoDefault[name]
      }
      return d
    },

    /** 新使用者情報の入力データを設定する */
    onSetSinSiyosya(val) {
      this.sinSiyosya = val
      this.isSinSiyosyaGetData = false
    },

    /** 住民票情報の入力データを設定する */
    onSetJyuminhyo(val) {
      this.jyuminhyo = val
      this.isJyuminhyoGetData = false
    },

    /** 車庫承諾書情報の入力データを設定する */
    onSetSyakoSyodakusyo(val) {
      this.syakoSyodakusyo = val
      this.isSyakoSyodakusyoGetData = false
    },
  },

  mounted() {
    this.observer = this.$refs.observer
  },

  created: async function () {
    // formがない場合は発注ホーム画面に遷移
    this.form = this.$route.params.form
    if (!this.form) {
      return this.$router.push({ name: 'OrderIndex' })
    }

    this.$store.commit('vehicle/changeDisplayButtomElem', false)
    this.spinerOn()

    this.setSyaryoMaker()
    this.setNumberArea()
    this.getNumberPlateOkiniiri().then((res) => {
      this.transports = res.data
    })

    await this.makeDefaultData()
    this.setDefaultData()

    if (this.form.syaryos) {
      const syaryo = this.form.syaryos[0]
      if (this.form.isFromHistoryEdit || this.form.isFromTrialEdit) {
        delete this.form.isFromHistoryEdit
        delete this.form.isFromTrialEdit
        syaryo.HANSYUTUKEN_URL = ''
        if (!Array.isArray(syaryo.OTHER_FILE_LIST)) {
          syaryo.OTHER_FILE_LIST = []
        }
        if (syaryo.TOUROKU_BANGO) {
          const torokuBango = syaryo.TOUROKU_BANGO.split(' ')
          syaryo.torokubango1 = torokuBango[0]
          syaryo.torokubango2 = torokuBango[1]
          syaryo.torokubango3 = torokuBango[2]
          syaryo.torokubango4 = torokuBango[3]
        }
        if (syaryo.SHITADORI_TOUROKU_BANGO) {
          const shitadoriTorokuBango = syaryo.SHITADORI_TOUROKU_BANGO.split(' ')
          syaryo.shitadoriTorokubango1 = shitadoriTorokuBango[0]
          syaryo.shitadoriTorokubango2 = shitadoriTorokuBango[1]
          syaryo.shitadoriTorokubango3 = shitadoriTorokuBango[2]
          syaryo.shitadoriTorokubango4 = shitadoriTorokuBango[3]
        }
      }
      this.syaryo = this.syaryoDefaultMerge(syaryo)
      this.addFileToS3()
    }

    this.isSinSiyosyaSetData = true
    this.isJyuminhyoSetData = true
    this.isSyakoSyodakusyoSetData = true
    this.setRikujiMeiAndCityCd()

    this.observer.reset()
    this.scroll('clear')
    this.spinerOff()
  },

  computed: {
    /** POS種別がTC-webか */
    isAAPosKbnTcWeb() {
      return this.form.HIKITORI_AA_POS_KBN === 3
    },

    /** 登録番号の項目全てを入力しているか判定 */
    isInputTorokuBnago() {
      return (
        this.syaryo.torokubango1 &&
        this.syaryo.torokubango2 &&
        this.syaryo.torokubango3 &&
        this.syaryo.torokubango4
      )
    },

    /** 登録番号の項目にエラーがあるか判定 */
    isInvalidTorokuBnago() {
      return (
        !this.syaryo.torokubango1 ||
        this.observer.fields.torokubango2.invalid ||
        this.observer.fields.torokubango3.invalid ||
        this.observer.fields.torokubango4.invalid
      )
    },

    /** 登録番号の項目全てが未入力か判定 */
    isEmptyTorokuBnago() {
      return (
        !this.syaryo.torokubango1 &&
        !this.syaryo.torokubango2 &&
        !this.syaryo.torokubango3 &&
        !this.syaryo.torokubango4
      )
    },

    /** 登録番号の入力が必須か判定 */
    isRequiredTorokuBnago() {
      return (
        !this.syaryo.SYADAI_BANGO ||
        (this.syaryo.SYADAI_BANGO &&
          !this.isInputTorokuBnago &&
          !this.isEmptyTorokuBnago)
      )
    },

    /** 下取り登録番号の項目全てを入力しているか判定 */
    isInputShitadoriTorokuBnago() {
      return (
        this.syaryo.shitadoriTorokubango1 &&
        this.syaryo.shitadoriTorokubango2 &&
        this.syaryo.shitadoriTorokubango3 &&
        this.syaryo.shitadoriTorokubango4
      )
    },

    /** 下取り登録番号の項目にエラーがあるか判定 */
    isInvalidShitadoriTorokuBnago() {
      return (
        !this.syaryo.shitadoriTorokubango1 ||
        this.observer.fields.shitadoriTorokubango2.invalid ||
        this.observer.fields.shitadoriTorokubango3.invalid ||
        this.observer.fields.shitadoriTorokubango4.invalid
      )
    },

    /** 下取り登録番号の項目全てが未入力か判定 */
    isEmptyShitadoriTorokuBnago() {
      return (
        !this.syaryo.shitadoriTorokubango1 &&
        !this.syaryo.shitadoriTorokubango2 &&
        !this.syaryo.shitadoriTorokubango3 &&
        !this.syaryo.shitadoriTorokubango4
      )
    },

    /** 下取り登録番号の入力が必須か判定 */
    isRequiredShitadoriTorokuBnago() {
      return (
        !this.syaryo.SHITADORI_SYADAI_BANGO ||
        (this.syaryo.SHITADORI_SYADAI_BANGO &&
          !this.isInputShitadoriTorokuBnago &&
          !this.isEmptyShitadoriTorokuBnago)
      )
    },

    /** バリデーション実行済みか */
    isVlidated() {
      return this.observer && this.observer.flags.validated
    },

    /** 車両メーカーの検証がアクティブか判定  */
    isSyaryoMakerTouched() {
      return (
        this.observer &&
        this.observer.fields.SYARYO_MAKER_MEI &&
        this.observer.fields.SYARYO_MAKER_MEI.touched
      )
    },

    /** 車名の検証がアクティブか判定  */
    isSyaryoMeiTouched() {
      return (
        this.observer &&
        this.observer.fields.SYARYO_MEI &&
        this.observer.fields.SYARYO_MEI.touched
      )
    },

    /** 下取り車両メーカーの検証がアクティブか判定  */
    isShitadoriSyaryoMakerTouched() {
      return (
        this.observer &&
        this.observer.fields.SHITADORI_SYARYO_MAKER_MEI &&
        this.observer.fields.SHITADORI_SYARYO_MAKER_MEI.touched
      )
    },

    /** 下取り車名の検証がアクティブか判定  */
    isShitadoriSyaryoMeiTouched() {
      return (
        this.observer &&
        this.observer.fields.SHITADORI_SYARYO_MEI &&
        this.observer.fields.SHITADORI_SYARYO_MEI.touched
      )
    },

    isHikitoriMaster() {
      return this.getHikitoriTabName() === 'MASTER'
    },
    isHikitoriDirect() {
      return this.getHikitoriTabName() === 'DIRECT'
    },
    isHikitoriFavorite() {
      return this.getHikitoriTabName() === 'FAVORITE'
    },
    isNosyaMaster() {
      return this.getNosyaTabName() === 'MASTER'
    },
    isNosyaFavorite() {
      return this.getNosyaTabName() === 'FAVORITE'
    },
    isNosyaDirect() {
      return this.getNosyaTabName() === 'DIRECT'
    },
    isHikitoriAA() {
      return !this.isLease && this.form.HIKITORI_AA_FLG
    },

    /** 納車先 */
    nosya() {
      return this.form[`NOSYA_${this.getNosyaTabName()}`]
    },

    /** 納車ヤード判定 */
    isNosyaYard() {
      return this.nosya && this.nosya.YUSO_KBN === Constant.YUSOKBN.YARD
    },

    /** 納車保管ヤード判定 */
    isNosyaHokanYard() {
      if (!this.isLease) return false
      else if (this.isNosyaYard) return true
      else
        return (
          this.nosya.LANDMARK_KBN &&
          Constant.LANDMARK_YARD_VALUS.indexOf(
            Number(this.nosya.LANDMARK_KBN)
          ) >= 0
        )
    },

    isTruck() {
      return (
        Number(this.syaryo.SYARYO_TYPE_KBN) === 2 ||
        Number(this.syaryo.SYARYO_TYPE_KBN) === 3
      )
    },

    /** 名変希望日 */
    meihenKiboubi: {
      get() {
        return this.syaryo.MEIHEN_KIBO_BI
          ? new Date(this.syaryo.MEIHEN_KIBO_BI)
          : null
      },
      set(newVal) {
        this.syaryo.MEIHEN_KIBO_BI = this.dateObjToStr(newVal)
      },
    },

    /** 請求可能な取引先か */
    isEnableInvoice() {
      return this.torihikiSaki.NAVI_SEIKYU_FLG
    }
  },
}
</script>

<style lang="sass" scoped>
@import '../../../assets/css/logico2'
.mx-15
  margin: 0 15px
#dropzone
  width: 50%
  @include sp
    width: 100%
.section-wrapper
  background: $baseGrayColor
  padding: 1%
section.order-syaryo,
section.order-hannyu,
section.order-jyotai,
section.order-biko,
section.order-option,
section.order-seikyu
  table
    th
      background: $baseBlueColor
      color: #fff
      width: 32%
      padding: 1.5%
    td
      width: 68%
      background: #fff
.add-vehicle-wrapper
  button
    background: orange !important
    color: white !important
    height: 70px
    @extend.f-size-28
    &:hover
      opacity: 0.8
.order-sticky-scroll
  @extend .sticky-scroll
  .order-sticky
    @extend .sticky
    padding: 4%
    top: 10px
    width: 100%
    height: 40px
    background: rgba(255,239,213,0.4)
    @include sp
      height: 70px
</style>



// WEBPACK FOOTER //
// src/components/order/meihen/Vehicle.vue